<template>
  <div id="pageRoot">

    <img src="/pages/img/sordovio/assets_p37/titulo.svg" style="height: 55px; left: 80px; top: 60px; position: absolute;"/>

    <span class="normalTheme pageInstruction" style="left: 55px; top: 140px;">
      <p>Lee el texto y completa con la palabra adecuada:</p>
    </span>

    <p class="pageElement textBaseCourier" id="text03">
      MUEREN / QUEDAN FRITAS
    </p>
    <p class="pageElement textBaseCourier" id="text04">
      ALMUERZAN / SE ALIMENTAN
    </p>

    <div class="enciclopedia-half" style="transform: translateY(-30px);">
      <img src="/pages/img/sordovio/assets_p37/chicharra.png" style="position: absolute; width: 300px; top: 30px; left: 320px;" />

      <p class="textBaseCourier" id="text06">
        LAS CIGARRAS HEMBRAS PONEN SUS HUEVOS Y ______________ POCO DESPUÉS. LOS INSECTOS JÓVENES (O NINFAS) CAEN AL SUELO Y PENETRAN LA TIERRA. LAS NINFAS VIVEN DENTRO DE LA TIERRA DE 2 A 17 AÑOS (SEGÚN LA ESPECIE) Y __________________ DE LA SAVIA DE LAS RAÍCES.
      </p>

      <saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01"/>
      <saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02"/>
    </div>
  </div>
</template>
<style scoped>
#text03
{
position: absolute;
left: 84px;
top: 222px;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text04
{
position: absolute;
left: 84px;
top: 272px;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text05
{
position: absolute;
width: 426px;
height: 41px;
left: 84px;
top: 323px;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text06
{
position: absolute;
width: 870px;
height: 297px;
left: 35px;
top: 192px;
 
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 190.28%;

color: #000000;
}
#inputField01
{
position: absolute;
width: 188px;
height: 31px;
left:610px;
top: 181px;

background-color: white;
font-size: 26px;
z-index: 5;
}
#inputField02
{
position: absolute;
width: 245px;
height: 31px;
left: 505px;
top: 320px;

background-color: white;
font-size: 26px;
z-index: 5;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 114.mp4", "vio/Video 115.mp4", "vio/Video 116b.mp4"]
    }
  }
}
</script>